import http from "./httpService";
import {apiUrl} from '../config.json';

const apiEndpoint = apiUrl + "/stories";

export function getStories() {
  return http.get(apiEndpoint);
}
